import React from 'react';
import { FaClipboard } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

interface CombinedSectionProps {
  title: string;
  content: string | null;
  processContent: (content: string | null) => JSX.Element | null;
  copyToClipboard: (text: string) => void;
  isTextSection: boolean; // New prop to differentiate between text and content sections
}

const CombinedSection: React.FC<CombinedSectionProps> = ({
  title,
  content,
  processContent,
  copyToClipboard,
  isTextSection,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <div className="flex items-center">
        <h3 className="font-semibold text-lg">{t(title)}</h3>
        {!isTextSection && (
          <div title="Copy to clipboard">
            <FaClipboard
              className="cursor-pointer w-4 h-4 ml-2"
              onClick={() => copyToClipboard(content!)} // Assuming content is not null here
            />
          </div>
        )}
      </div>
      <div
        className={
          isTextSection ? 'pl-4 border-l-4 border-gray-500' : 'pl-4 border-l-4 border-green-500'
        }
      >
        {processContent(content)}
      </div>
    </div>
  );
};

export default CombinedSection;
